import { string } from '@amcharts/amcharts4/core';
import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { TreeNode } from 'primeng/api';
import { BaseService } from 'src/app/shared/services/base.service';
import { NotificationsService } from 'src/app/shared/services/notification.service';
import { FileUtility } from 'src/app/shared/utility/file.utility';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { LibraryDetails } from '../../model/LibraryDetails.model';
import { DocumentlibraryConstantsService, DocumentType } from '../../service/documentlibrary-constants.service';
import { DocumentlibraryService } from '../../service/documentlibrary.service';

@Component({
  selector: 'ara-documnent-library',
  templateUrl: './documnent-library.component.html',
  styleUrls: ['./documnent-library.component.css']
})
export class DocumnentLibraryComponent implements OnInit {
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  files: TreeNode[] = [];
  selectedNodes: TreeNode[] = [];
  cols: any[];
  fileUploadDialog: boolean = false;
  invalidFiles: boolean = false;
  addFolderDialog: boolean = false;
  document: LibraryDetails = new LibraryDetails();
  loggedInUserJSON: any;
  userPermissions: UserPermissionParameters = new UserPermissionParameters();
  DocumentType = DocumentType;
  accept: string = ".pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.xls,.XLS";
  FileExtension: string = "";
  fileTypes: any[] = [];
  FileFormat: string = "";
  selectedfileFormat: string = "";
  AllChildIds: number[] = [];
  rootNode: TreeNode[] = [];
  rowNodes: TreeNode[] = [];
  selectedAll: boolean = true;
  node: TreeNode;
  PreviewUrl: any;
  display: boolean;
  isAdmin: boolean = false;
  selectAll: boolean = false;
  independentPermissions: any;
  dialogType: string;
  alertType: string;
  successDetails: any;
  errorDetails: any;
  confirmMessage: string;
  currentNode: any;

  constructor(
    private baseService: BaseService,
    private dlService: DocumentlibraryService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.routesFlag = DocumentlibraryConstantsService.DLNavigation.InnerRoutes;
    this.reportRoutes = DocumentlibraryConstantsService.DLNavigation.ReportRoutes;
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.getLibraryDetails(this.independentPermissions.DL_Admin ||   this.independentPermissions.SUPER_Admin);
    this.getFileTypeDetails();
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'UpdatedBy', header: 'Updated By' },
      { field: 'RevisionDate', header: 'Revision Date' },
      { field: 'versionNumber', header: 'Version Number' },
    ];
  }

  closePopUp() {
    this.fileUploadDialog = false;
    this.addFolderDialog = false;
    this.EditFolderDialog = false; 
  }
  onInputFilesUpdated(Files) {
    this.document.File = Files;
  }

  uploadFileOrFolder(type) {
   if( this.document.Name.trim()!=""){
    this.baseService.showRootLoader = true;
    this.document.Id = 0;
    this.document.Type = type;
    this.document.CreatedBy = this.loggedInUserJSON.UserId;
    this.document.Type == DocumentType.Folder ? this.document.File = [] : "";
    this.document.Name = this.document.Name;
    if(this.document.Type==DocumentType.File)
    this.document.Name +="." +this.document.File[0].Name.split('.').pop();
 
    const apiRequest = {
      Model: this.document
    };
    this.dlService.uploadDocument(
      apiRequest,
      this.callbackMethodForUploadDocument.bind(this)
    );
  }
  else{
    this.notificationsService.toastNotify(
      "error",
      "Error Message",
      "Folder or File name should not be blank!"
    ); 
  }
}

  callbackMethodForUploadDocument(response) {
    if (response && response.Success) {
      if (response.Result) {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "Folder or File already exists!"
        );
      }
      else {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "Folder Added successfully"
        );
      }
      this.baseService.showRootLoader = false;
      window.location.reload();
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!"
      );
      window.location.reload();
    }
    this.document.Type == DocumentType.Folder ? this.addFolderDialog = false : this.fileUploadDialog = false;
    this.document = new LibraryDetails();
  }

  addFolderOrFileBtn(Id, type) {
    this.document.ParentId = Id;
    this.document.Name = "";
    this.document.File = [];
    this.document.Version = "";
    this.selectedfileFormat = "";
    this.FileFormat = "";
    type == DocumentType.Folder ? this.addFolderDialog = true : this.fileUploadDialog = true;
  }

  getLibraryDetails(isAdmin) {
    const apiRequest = {
      Model: {
        "isAdmin": isAdmin
      },
    };
    this.dlService.getLibraryDetails(
      apiRequest,
      this.callbackMethodForGetLibraryDetails.bind(this)
    );
  }
  callbackMethodForGetLibraryDetails(response) {
    if (response.Success) {
      this.files = response.Result;
    }
  }
  downloadFileOrFolder(rowNode, type) {
    this.notificationsService.toastNotify('info', 'Information Message', 'Download is in Progress!');
    if (type == DocumentType.File) {
      let Files = rowNode.data.File;
      if (Files.length) {
        saveAs(Files[0].SourceUrl);
      }
    }
    if (type == DocumentType.Folder) {
      const apiRequest = {
        Model: {
          data: rowNode.data,
          children: rowNode.children
        },
      };
      this.dlService.downloadZIP(
        apiRequest,
        this.callbackMethodForDownloadZIP.bind(this)
      );
    }
  }
  callbackMethodForDownloadZIP(response) {
    var fileDownLoadName = "DocumentLibrary.zip";
    FileUtility.downloadPDF(response, fileDownLoadName);
  }
  downloadFolder(data) {
    if (data) {
      saveAs(data);
    }
  }
  downloadFile(Files) {
    if (Files.length) {
      saveAs(Files[0].SourceUrl);
    }
  }

  getAllChildrenIds(node) {
    node.children.forEach(element => {
      this.AllChildIds.push(element.data.Id);
      if (element.data.type === 1) {
        this.getAllChildrenIds(element);
      }
    });
  }

  deleteDocument(node) {
    this.AllChildIds = [];
    this.AllChildIds.push(node.data.Id);
    this.getAllChildrenIds(node);
    const apiRequest = {
      Model: { NodeIds: this.AllChildIds }
    };
    this.dlService.deleteDocument(
      apiRequest,
      this.callbackMethodForDeleteDocument.bind(this)
    );
  }
  callbackMethodForDeleteDocument(response) {
    if (response.Result != null) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Document Deleted Successfully"
      );
      window.location.reload();
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Cannot delete document."
      );
    }
  }

  revertDocument(node) {
    this.AllChildIds = [];
    this.AllChildIds.push(node.data.Id);
    this.getAllChildrenIds(node);
    const apiRequest = {
      Model: { NodeIds: this.AllChildIds, NodeDetails: node.data }
    };
    this.dlService.revertDocument(
      apiRequest,
      this.callbackMethodForRevertDocument.bind(this)
    );

  }

  callbackMethodForRevertDocument(response) {
    if (response.Result != null) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Document Reverted Successfully"
      );
      window.location.reload();
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Cannot Revert document."
      );
    }
  }

  showDialog(node) {
    this.PreviewUrl = node.data.File[0].SourceUrl;
    this.display = true;
  }

  getFileTypeDetails() {
    const apiRequest = {
      Model: {},
    };
    this.dlService.getFileTypeDetails(
      apiRequest,
      this.callbackMethodForGetFileTypeDetails.bind(this)
    );
  }
  callbackMethodForGetFileTypeDetails(response) {
    if (response.Success) {
      response.Result.forEach(element => {
        this.fileTypes.push(
          {
            'value': element.NameFormat,
            'label': element.FileType
          });
      });
    }
  }

  selectNameFormat(NameFormat) {
    this.FileFormat = "";
    this.FileFormat = NameFormat;
  }

  checkNode(node, event): void {
    this.updateChildNodeCheckbox(node, event.target.checked);
    this.updateParentNodeCheckbox(node.parent);
  }

  private updateChildNodeCheckbox(node, checked: boolean): void {
    node.data.isChecked = checked;
    this.selectAll = checked ? this.selectAll : false;
    node.data.indeterminate = false;
    if (node.children && node.children.length > 0) {
      node.children.forEach((child) => this.updateChildNodeCheckbox(child, checked));
    }
  }

  private updateParentNodeCheckbox(node): void {
    if (!node) {
      return;
    }

    let allChildrenChecked = true;
    let noChildChecked = true;

    for (const child of node.children) {
      if (!child.data.isChecked || child.data.indeterminate) {
        allChildrenChecked = false;
      }
      if (child.data.isChecked || child.data.indeterminate) {
        noChildChecked = false;
      }
    }

    if (allChildrenChecked) {
      node.data.isChecked = true;
      node.data.indeterminate = false;
    } else if (noChildChecked) {
      node.data.isChecked = false;
      node.data.indeterminate = false;
    } else {
      node.data.isChecked = false;
      node.data.indeterminate = true;
    }
    this.updateParentNodeCheckbox(node.parent);
  }

  // downloadSelected() {
  //   this.rootNode = [...this.files.map(element => {
  //     if (element.data.isChecked || element.data.indeterminate) {
  //       return this.getSelectedNode(element);
  //     }
  //   })];
  //   this.rootNode = [...this.rootNode.filter(e => this.getValidNodes(e))];
  //   console.log(JSON.stringify(this.rootNode));
  // }

  // getValidNodes(node): any {
  //   if (node.data.isChecked) {
  //     return node;
  //   } else if (node.data.indeterminate && node.children) {
  //     node.chidlren.filter(c => this.getValidNodes(c));
  //     return node;
  //   }
  // }

  // getSelectedNode(element): any {
  //   if (element.data.isChecked) {
  //     return element;
  //   }
  //   else if (element.data.indeterminate && element.children) {
  //     element.children.map(c => {
  //       if (c.data.isChecked || c.data.indeterminate) {
  //         return this.getSelectedNode(c);
  //       }
  //     })
  //     return element;
  //   }
  // }

  // checkAllNodes(event){
  //     this.files.forEach(element => {
  //       this.checkNode(element,event);
  //     });
  // }


  downloadSelected() {
    this.rootNode = [];
    this.files.forEach(element => {
      if (element.data.isChecked) {
        this.rootNode.push(element);
      }
      else if (element.data.indeterminate) {
        this.node = { data: {}, children: [] };
        this.node.data = element.data;

        element.children.forEach(element => {
          if (element.data.isChecked) {
            this.node.children.push(element);
          }
          else if (element.data.indeterminate) {
            this.AddChild(element, this.node);
          }
        });
        this.rootNode.push(this.node);
      }
    });

    const apiRequest = {
      Model: {
        'data': { name: "SelectedData" },
        'children': this.rootNode
      }
    };
    this.dlService.downloadZIP(
      apiRequest,
      this.callbackMethodForDownloadZIP.bind(this)
    );
  }

  AddChild(child: TreeNode, node: TreeNode) {
    if (child.data.isChecked) {
      node.children.push(child);
    }
    else if (child.data.indeterminate) {
      node.children.push({ data: child.data, children: [] });
      child.children.forEach(element => {
        this.AddChild(element, node.children[node.children.findIndex(s => s.data == child.data)]);
      });
    }
  }

  checkAllNodes(event) {
    this.files.forEach(element => {
      this.checkelement(element, event.target.checked);
    });
  }
  checkelement(element: TreeNode, value) {
    element.data.isChecked = value;
    element.children.forEach(child => {
      this.checkelement(child, value);
    });
  }
  confirmDelete(node) {
    let fileName = (node.data.type == 1) ? node.data.name + " folder." : node.data.name + " file.";
    this.dialogType = "ConfirmDelete";
    this.alertType = "Confirm";
    this.successDetails = null;
    this.errorDetails = null;
    this.confirmMessage = "You are about to delete " + fileName + " Are you sure?";
    this.currentNode = node;
  }

  confirmRevert(node) {
    let fileName = (node.data.type == DocumentType.Folder) ? node.data.name + " folder." : node.data.name + " file.";
    this.dialogType = "ConfirmRevert";
    this.alertType = "Confirm";
    this.successDetails = null;
    this.errorDetails = null;
    this.confirmMessage = "You are about to revert " + fileName + " Are you sure?";
    this.currentNode = node;
  }

  onOkClickedForConfirmation() {
  }

  onYesClickedForConfirmation() {
    switch (this.dialogType) {
      case "ConfirmDelete":
        this.deleteDocument(this.currentNode);
        break;
      case "ConfirmRevert":
        this.revertDocument(this.currentNode);
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  onNoClickedForConfirmation() {
    switch (this.dialogType) {
      case "ConfirmDelete":
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  EditType:string;
  EditTypeid:number;
  EditName:string;
  
  EditFolderDialog: boolean = false; 
 


RenameBtn(node) {
 
  this.EditType = (node.data.type == 1) ? " Folder" :" File";
  this.EditTypeid= node.data.type;
  this.EditName = (node.data.type == 1) ?  node.data.name : node.data.File[0].name;
  this.FileExtension= (node.data.type == 1)?"":"."+this.EditName.split('.').pop(); 
  this.document.Name=node.data.name.toString().replace(this.FileExtension,"");
  this.document.Id=node.data.Id  ;
  this.EditFolderDialog = true; 
}

  RenameFileOrFolder()
  {
    //console.log(this.document.Id)
    
    this.baseService.showRootLoader = true;
    this.document.Type=this.EditTypeid;
    this.document.CreatedBy = this.loggedInUserJSON.UserId;
    this.document.Name +=this.FileExtension;// ((this.EditTypeid==2)?".pdf":"");
    this.document.Version = this.EditName;//+ this.FileExtension;// ((this.EditTypeid==2)?".pdf":"");

    this.document.ParentId=0;
    const apiRequest = {
      Model: this.document
    };
    this.dlService.RenameDocument(
      apiRequest,
      this.callbackMethodForRenameDocument.bind(this)
    );
  }

  callbackMethodForRenameDocument(response) {
     
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
      if (!response.Result) 
      {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "Folder or File already exists!"
        );
      }
      else {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "Renamed successfully"
        );
        window.location.reload();
      }
      
      
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!"
      );
     // window.location.reload();
    }
    this.EditFolderDialog = false; 
    this.document = new LibraryDetails();
  }


}

